'use strict';

var ProfileChartFlightCardDirective = function ProfileChartFlightCardDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/profile-chart-flight-card.html'),
    controller: 'ProfileChartFlightCardController',
    scope: {
      entity: '=',
      removeReferenceEntity: '&?'
    }
  };
};
ProfileChartFlightCardDirective.$inject = [];
module.exports = ProfileChartFlightCardDirective;